import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { ServiceBase } from "./service.base";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ArtistDashboard } from "../models/response/artistdashboard.models";
import { GalleryDashboard, GallerySalesChartResponse } from "../models/response/galleryDashboard.models";
import { AdminDashboardApiResponce, ArtistInsightsSeries, StripeInsightsChart } from "../models/response/artistoverlaydashboard.model";

@Injectable({
    providedIn: 'root'
  })
  export class DashboardService extends ServiceBase {

    constructor(private http: HttpClient, authService: AuthService) {
      super(authService);
    }

    public getArtistDashboard(): Observable<ArtistDashboard> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/dashboard';
        const method: string = '/artist';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.get<ArtistDashboard>(url, httpOptions);
      }

      public getGalleryDashboard(): Observable<GalleryDashboard> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/dashboard';
        const method: string = '/gallery';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.get<GalleryDashboard>(url, httpOptions);
      }
    public getAllSubscriptions(): Observable<AdminDashboardApiResponce> {
        var httpOptions = this.RequestHeaders();
        const api: string = '/dashboard';
        const method: string = '/admin';
        const url: string = environment.BASE_API_PATH + api + method;
        return this.http.get<AdminDashboardApiResponce>(url, httpOptions);
    }

    public getSubscriptionDurationAdmin(insightsDurationDays: number): Observable<StripeInsightsChart[]> {
      var httpOptions = this.RequestHeaders();
      const api: string = '/dashboard';
      const method: string = '/adminStripeInsightsChartsByDuration/' + insightsDurationDays;
      const url: string = environment.BASE_API_PATH + api + method;
      return this.http.get<StripeInsightsChart[]>(url, httpOptions);
    }

    public getSubscriptionDurationArtist(insightsDurationDays: number): Observable<ArtistInsightsSeries[]> {
      var httpOptions = this.RequestHeaders();
      const api: string = '/dashboard';
      const method: string = '/artistChartsByDuration/' + insightsDurationDays;
      const url: string = environment.BASE_API_PATH + api + method;
      return this.http.get<ArtistInsightsSeries[]>(url, httpOptions);
    }

    public getSubscriptionDurationGallery(insightsDurationDays: number): Observable<GallerySalesChartResponse[]> {
      var httpOptions = this.RequestHeaders();
      const api: string = '/dashboard';
      const method: string = '/galleryChartsByDuration/' + insightsDurationDays;
      const url: string = environment.BASE_API_PATH + api + method;
      return this.http.get<GallerySalesChartResponse[]>(url, httpOptions);
    }

}

export class StripeInsightsMetricSeries {
  Metric?: string | undefined;
  SeriesName?: string;
  TopSummaryStatus?: string;
  ChartsValue?: AdminInsightsMetricDataPoint[];
}

export class AdminInsightsMetricDataPoint {
  Label!: string;
  // DataPointLabel?: string [] | undefined;  //shows when you hover over the datapoint 
  Value!: number;
}